var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatSetsUsApartRightTriangleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 299,
    viewBox: "0 0 119 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70692 27.6141C-4.84523 17.0093 3.21564 0.151963 17.4669 0.929527L373.906 20.3773C385.283 20.9981 392.384 32.9758 387.468 43.2559L269.938 289.043C265.023 299.323 251.242 301.315 243.615 292.849L4.70692 27.6141Z",
    fill: "url(#paint0_linear_304:2254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304:2254",
    x1: -21.2308,
    y1: -1.18187,
    x2: 445.348,
    y2: 221.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3300",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatSetsUsApartRightTriangleRed);
export default __webpack_public_path__ + "static/media/what-sets-us-apart-right-triangle-red.1eee1f82.svg";
export { ForwardRef as ReactComponent };